/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCategoriesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CategoriesDataActions.g';
import { Category } from '@msdyn365-commerce/retail-proxy';

export class GetCategoriesInput implements Msdyn365.IActionInput {
    constructor() {}
    public getCacheKey = () => `Get-Categories`;
    public getCacheObjectType = () => 'Get-Categories';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}
export interface IGetCategoriesData {
    filteredCategories: Category[];
    parentCategory?: Category | undefined;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCategoriesInput();
};

async function action(input: GetCategoriesInput, ctx: Msdyn365.IActionContext): Promise<IGetCategoriesData> {
    const recId = Number(ctx.requestContext.urlTokens.recordId);
    const getCategories: Category[] = await getCategoriesAsync(
        { callerContext: ctx },
        ctx.requestContext.apiSettings.channelId
    );

    const filteredCategories = recId ? getCategories.filter((item: Category) => item.ParentCategory === recId) : getCategories;
    const category = getCategories.find((item: Category) => item.RecordId === recId);

    return { filteredCategories: filteredCategories, parentCategory: category };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCategoriesData>>action,
    id: 'GetCategories',
    input: createInput
});
